import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

export interface EmployeeSummaryDto {
  id: number;
  fullName: string;
  email: string | null;
}

// No printer-default writer here on purpose. Storing the operator's own default goes through
// `savePrinterDefaults` in @/lib/me: PATCH /api/employees/{id} needs `employees:write` (Admin only),
// replaces the whole record — so one column meant a read-modify-write that round-tripped the
// signature blob and sent a possibly-null email into a NotEmpty().EmailAddress() validator.
export const employeesApi = {
  list: (params: { q?: string; pageSize?: number } = {}): Promise<PagedResult<EmployeeSummaryDto>> => {
    const sp = new URLSearchParams();
    if (params.q) sp.set("q", params.q);
    sp.set("pageSize", String(params.pageSize ?? 20));
    sp.set("deleted", "false");
    return apiFetch<PagedResult<EmployeeSummaryDto>>(`/api/employees?${sp.toString()}`);
  },
};
